import { Form, DatePicker } from "antd";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const InputDate = forwardRef(({ label, placeholder, name, disabled, required, format = 'YYYY-MM-DD' }, ref) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={[{ required: required, message: `${label} is required!` }]}
      className="ant-form-item-custom-style"
    >
      <DatePicker
        ref={ref}
        style={{ width: "100%" }}
        placeholder={placeholder || label}
        disabled={disabled}
        format={format}
        // Additional props can be added here
      />
    </Form.Item>
  );
});

InputDate.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  format: PropTypes.string,
};

export default InputDate;
